<template>
    <div class="form-group">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label + (error && errorMessage ? ` ${$t('dash-{s}', {'s': errorMessage})}` : '') }}</slot>
        </label>
        <div class="input-group">
            <input
                type="email"
                class="form-control"
                :placeholder="placeholder"
                :id="id.ID()"
                :value="value"
                @input="$emit('input', $event.target.value)"
                @keyup.enter="$emit('enter')"
                :aria-label="label"
            /> 
            <slot name="append" />
        </div>
    </div>
</template>

<script>
import id from 'src/modules/uuid.js'

export default {
    props: {
        value: String,
        label: {
            type: String,
            required: true,
        },
        srOnly: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        hideText: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            id: new id(),
        }
    },
    computed: {
        validEmail() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.value);
        }
    }
}
</script>
